import axios from 'axios';
import * as Sentry from '@sentry/react';

const API_URL = import.meta.env.VITE_API_URL;

let reportedThisSession = false;

export async function checkBackendHealth() {
  try {
    await axios.get(`${API_URL}/health`, { timeout: 3000 });
    return true;
  }
  catch (e) {
    if (!reportedThisSession) {
      Sentry.captureMessage('Backend unreachable', {
        level: 'error',
        tags: { type: 'backend_health' },
      });
      reportedThisSession = true;
    }
    return false;
  }
}
